export enum StarFill {
    Full = 'full-star',
    Half = 'half-star',
    Empty = 'empty-star',
}

export const StarSize = {
  smaller: '14px',
  small: '17px',
  medium: '26px',
  large: '40px'
} as const;

export const StarColour = {
  yellow: 'yellow',
  newBrandYellow: 'new-brand-yellow',
  blade: 'blade'
} as const;

export const RatingText = [
	'awful',
	'not good',
	'OK',
	'good!',
	'great!'
] as const;

export const RatingTextNew = [
	'awful',
	'not good',
	'ok',
	'good',
	'great'
] as const;
